import type { MaterialPresentationType } from '../materials-catalog/index.js';

export const materialOrderingSourceValues = ['station', 'company', 'catalog'] as const;
export type MaterialOrderingSource = (typeof materialOrderingSourceValues)[number];

export const materialOrderingScopeValues = ['station', 'company'] as const;
export type MaterialOrderingScope = (typeof materialOrderingScopeValues)[number];

export const materialOrderingDefaultModeValues = [
  'published',
  'alpha_asc',
  'alpha_desc',
] as const;
export type MaterialOrderingDefaultMode = (typeof materialOrderingDefaultModeValues)[number];

export interface MaterialOrderingItem {
  materialId: string;
  presentationType: MaterialPresentationType;
  sortOrder: number;
  isPinned: boolean;
  isHidden: boolean;
}

export interface MaterialOrderingOverride {
  id: string;
  companyId: string;
  stationId: string | null;
  defaultMode: MaterialOrderingDefaultMode;
  items: MaterialOrderingItem[];
  createdAt: string; // ISO datetime
  updatedAt: string; // ISO datetime
}

export interface GetMaterialOrderingRequest {
  companyId: string;
  stationId?: string | null;
}

export interface GetMaterialOrderingResponse {
  ordering: MaterialOrderingOverride | null;
}

export interface UpsertMaterialOrderingRequest {
  companyId: string;
  stationId?: string | null;
  defaultMode?: MaterialOrderingDefaultMode;
  items: MaterialOrderingItem[];
}

export interface UpsertMaterialOrderingResponse {
  ordering: MaterialOrderingOverride;
}

export interface ResolveMaterialOrderingRequest {
  companyId: string;
  storeId: string;
  locationId: string;
  stationId: string;
  effectiveOn?: string; // ISO date (YYYY-MM-DD)
  includeInactive?: boolean;
  scope?: MaterialOrderingScope;
}

export interface ResolvedMaterialOrderingItem {
  materialId: string;
  presentationType: MaterialPresentationType;
  sortOrder: number | null;
  isPinned: boolean;
  isHidden: boolean;
  source: MaterialOrderingSource;
}

export interface ResolveMaterialOrderingResponse {
  items: ResolvedMaterialOrderingItem[];
  defaultMode?: MaterialOrderingDefaultMode;
}
